module.exports = __webpack_public_path__ + "static/img/gerenshengxian.723ad79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gerenshengxian.jpg
// module id = fLPu
// module chunks = 52